<template>
    <section :class="[shit$(`font:14px; letter-s:1.12px; relative; z:100;`)]">
        <connect-button @changeData="o => changeConnectButtonStatus(o)"
            :status="connectButtonStatus"
        ></connect-button>
        <el-collapse-transition>
            <connect-pop v-show="switchIs" :status="connectPopStatus"></connect-pop>
        </el-collapse-transition>
    </section>
</template>

<script>
import ConnectButton from '@/code-lab/component/robot-connect/device-manage/connect-button.vue'
import ConnectPop from '@/code-lab/component/robot-connect/device-manage/connect-pop.vue'
import { store } from '@/code-lab/component/robot-connect/device-manage/observable/store.js'
import { store as robotConnectStore, mutations as robotConnectMutations } from '@/code-lab/component/robot-connect/robotConnectOber.js'
import { store as playButtonStore, mutations as playButtonMutations } from '@/code-lab/component/robot-connect/play-button/observable.js'
import toolMix from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { mapState } from 'vuex'
export default {
    components: { ConnectButton, ConnectPop },
    mixins: [ toolMix ],
    computed: {
        connectPopStatus () {
            return store.state.pop.connectPopStatus
        },
        connectButtonStatus () {
            return store.state.button.connectButtonStatus
        },
        switchIs () {
            return store.state.pop.switchIs
        },
        ...mapState('rmsConnection', { rmsConnectDevices: 'connectDevices' }),
        ...mapState('teachConnection', { teachConnectDevices: 'connectDevices' }),
        ...mapState('quickConnection', { quickConnectDevices: 'connectDevices' }),
        ...mapState(['currentVersion']),
        stopCode () { return store.state.pop.stopCode },
        stopVoice () { return store.state.pop.stopVoice },
    },
    watch: {
        quickConnectDevices (data) {
            if (!this.b$.quick || !data.length) return
            store.commit("pop/connectPopStatus", { connectPopStatus: 'quickConnected.normal' })
            store.commit('button/connectButtonStatus', { connectButtonStatus: 'connected.normal' })
            store.commit('button/connectedSelect', { text: `${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_0") }：${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_1") }「${ this.strSliceStarAndEndT(data[0].clientName, 8, 4) }」${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_2") }` })
            store.commit('button/connectedNormal', { text: `${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_3") }：${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_4") }「${ this.strSliceStarAndEndT(data[0].clientName, 8, 4) }」${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_5") }` })
            store.commit('button/current', { current: 1 })
            store.commit('button/clickData', { clickData: false }) 
        },
        rmsConnectDevices (data) {
            if (!this.b$.rms || !data.length) return
            store.commit("pop/connectPopStatus", { connectPopStatus: 'connected.set' })
            store.commit('button/connectButtonStatus', { connectButtonStatus: 'connected.normal' })
            store.commit('button/connectedSelect', { text: `${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_6") }：${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_7") }「${ data.length }${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_8") }」${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_9") }` })
            store.commit('button/connectedNormal', { text: `${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_10") }：${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_11") }「${ data.length }${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_12") }」${ this.$t("code-lab/component/robot-connect/device-manage/device-manage.vue_13") }` })
            store.commit('button/current', { current: 1 })
        },
        teachConnectDevices (data) {
            if (!this.b$.rms || !data.length) return
            const name = this.groupsFormatter(data.map(mp => mp.name || ''))
            store.commit('pop/connected.seted.robot', { label: name })
            store.commit('pop/connectPopStatus', { connectPopStatus: 'connected.seted' })
            store.commit('button/current', { current: 1 })
            this.$store.commit('teachConnection/switchRmsHandler', false)
        },
        stopCode (val) {
            const deviceCurrent = val
            const playCurrent = playButtonStore.currentChecked
            if (deviceCurrent && playCurrent) {
                const fns = robotConnectStore.stop.map[robotConnectStore.stop[deviceCurrent] + '/' + robotConnectStore.play[playCurrent]]
                fns.forEach(fn => playButtonMutations[fn]())
            } else if (!val) {
                playButtonMutations.addcommonList()
                playButtonMutations.addDefaultValue()
            } else {
                val === '1.0' && playButtonMutations.addStudent()
                val === '1.1' && playButtonMutations.addTeacher()
            }
            robotConnectMutations.playValue(playButtonStore.currentChecked)
            robotConnectMutations.stopValue(val)
            // l$(val, 'stopCode', playButtonStore.currentChecked)
        },
    },
    methods: {
        updateDate (data) { Object.assign(this, data) },
        changeConnectButtonStatus (obj) {
            this.updateDate(obj)
        },
        groupsFormatter(arr) {
            const fn1 = this.formatStringSubstrT
            const fn = (data, end = 13) => data.reduce((a, b) => [...a, ...[ b.length > end ? fn1(b, { s: 0, e: end }, '..') : b ]], [])
            const res = arr.length >= 5
            ? [...fn(arr.slice(0, 4)), ...[fn1(arr[4], { s: 0, e: 4 }, '...')]]
            : arr.length > 1 ? fn(arr, 18) : fn(arr, 25)
            return res.join('、')
        },
    },
}
</script>
